const angular = require('angular');

const { spinnerComponentDefinition } = require('./spinner.component');

angular.module('oly.common')
    .component('wowLoadingSpinner', spinnerComponentDefinition);



// WEBPACK FOOTER //
// ./src/olycommon/loading-spinner/index.js